var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterIcon = function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.425 5.13c-.798.362-1.649.602-2.535.718a4.5 4.5 0 0 0 1.935-2.51 8.6 8.6 0 0 1-2.79 1.1A4.35 4.35 0 0 0 15.824 3c-2.435 0-4.396 2.04-4.396 4.543 0 .36.03.706.102 1.036-3.657-.185-6.893-1.994-9.067-4.751a4.7 4.7 0 0 0-.602 2.296c0 1.573.785 2.967 1.954 3.774a4.24 4.24 0 0 1-1.987-.56v.05c0 2.208 1.524 4.04 3.524 4.463-.358.101-.748.15-1.153.15-.282 0-.566-.017-.833-.078.57 1.799 2.187 3.121 4.11 3.164a8.66 8.66 0 0 1-5.454 1.937c-.26 0-.378.36-.15.485A12.1 12.1 0 0 0 7.716 21c8.095 0 12.52-6.923 12.52-12.924q-.001-.3-.016-.587a8.9 8.9 0 0 0 2.205-2.358"
  })));
};
export default SvgTwitterIcon;